import { Configs } from 'constants/app/configs';
import { ViewModes } from 'interfaces';

const STRIPE_KEYS = {
  [ViewModes.DEFAULT]: '',
  [ViewModes.FTNFT_AM]: '',
  [ViewModes.KIOSK]: '',
  [ViewModes.KIOSK_AM]: '',
  [ViewModes.KIOSK_VENICE]:
    'pk_live_51MQnsXCx1nXuEVD79VXgduOsA5SJ2yCi5GmdroTARamBLIExFYEgmZAZ2BzLfpZfJVghdKOl6Ae6yCsdMmd9zWMC00R0EWyMRj'
};
export const STRIPE_KEY = STRIPE_KEYS[Configs.VIEW_MODE];
